<template>
  <div class="upload-page">

    <transition name="slide-fade" mode="out-in" appear>
      <cd-section v-if="!uploadSuccessful" key="upload-view">
        <p>
          Please upload the photos requested
          by your Spring Financial Representative.
        </p>
        <cd-field>
          <cd-file-input
            class="file-picker"
            label="Choose Photo(s) to Upload"
            centered
            fullwidth
            boxed
            multiple
            color="white"
            accept="image/*"
            v-model="files"
          ></cd-file-input>
        </cd-field>

        <div class="file-list" v-if="files">
          <div class="file-list__title" v-if="files.length">File(s):</div>
          <div
            v-for="(file, index) in files"
            :key="index"
            class="file-list__item"
          >
            {{ file.name }}
            ({{ (file.size / 1000).toFixed(2) }} KB)
          </div>
        </div>

        <div class="upload-progress">
          <transition name="fade">
            <div class="upload-progress__empty" v-if="loading">
              <div class="upload-progress__filled"
                :style="`width: ${uploadProgress}%`"
              ></div>
              <div class="upload-progress__border"

              >{{ uploadProgress }}%</div>
            </div>
          </transition>
        </div>


        <cd-button
          class="upload-button"
          fullwidth
          color="primary"
          :loading="loading"
          :disabled="disableUploadButton"
          @click="uploadFile()"
        >
          Upload
        </cd-button>

        <div class="errors" v-if="errors.length > 0">
          <div
            v-for="(error, index) in errors"
            :key="index"
            class="error-message"
          >
            {{ errors[0] }}
          </div>

        </div>
      </cd-section>

      <cd-section v-else key="success-view">
        <div class="success-message">
          <i class="fa fa-check-circle success-message__icon"></i>
          <div class="success-message__text">
            Upload Successful<br><br>
            To upload more photos, please request a
            new link from your Spring Financial Representative.
          </div>
        </div>
      </cd-section>
    </transition>

  </div>
</template>

<script>
/**
 * <upload-image></upload-image>
 * @desc a view that allows users to upload a photo with a valid token
 */
import axios from 'axios'
require('formdata-polyfill')

export default {
  // Name
  name: 'upload-image',

  // Data
  data () {
    return {
      msg: '',
      files: undefined,
      loading: false,
      tokenIsValid: true,
      toast: {
        text: undefined,
        show: false,
        color: 'success'
      },
      uploadProgress: 0,
      errors: [],
      uploadSuccessful: false
    }
  },

  // Computed
  computed: {
    fileExists () {
      if (!this.files) return false
      if (this.files.length === 0) return false
      return true
    },
    token () {
      const url = new URL(window.location)
      return url.searchParams.get('token')
    },
    disableUploadButton () {
      return !this.fileExists || this.loading || !this.token || this.uploadSuccessful
    }
  },

  // Methods
  methods: {
    getFiles () {
      const files = []
      for (let i = 0; i < this.files.length; i++) {
        const file = this.files[i]
        files.push(file)
      }
      return files
    },

    formatParams (params) {
      let data = new FormData()
      for (let i in params) {
        if (params[i]) {
          if (Array.isArray(params[i])) {
            for (let j in params[i]) {
              data.append('file' + j, params[i][j])
            }
          } else {
            data.append(i, params[i])
          }
        }
      }
      return data
    },

    async uploadFile () {
      if (!this.token) return
      try {
        this.errors = []
        if (!this.files) return
        this.loading = true
        this.uploadProgress = 0
        const params = this.formatParams({
          token: this.token,
          files: this.getFiles()
        })
        await axios.post(
          process.env.API_URL + 'upload/images',
          params,
          {
            onUploadProgress: (progressEvent) => {
              this.uploadProgress = Math.round(
                (progressEvent.loaded / progressEvent.total) * 100
              ) || 0
            }
          }
        )
        this.uploadSuccessful = true
      } catch (error) {
        console.warn(error)
        const errors = error.response ? error.response.data.errors : undefined
        if (!errors) {
          this.errors.push('An error occurred. Please try again or contact your representative.')
          return
        }
        for (let i in errors) {
          for (let j in errors[i]) {
            this.errors.push(errors[i][j])
          }
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.upload-page {
  width: 100%;
  max-width: 500px;
  flex-grow: 1;
  margin:auto;
}
.file-picker {
  margin: 20px 0;
  min-width: 100%;
  text-align: center;
  border: 1px solid #d6d6d6;
  font-size: 18px;
  box-shadow: 0px 3px 1px rgba(214, 214, 214, .5);
  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
  // background-color: #fff;

  // Fix for file input button to stay within container bounds
  :deep(.file-label) {
    width: 100%;
    display: flex;

    .file-cta {
      width: 100%;
      min-height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      background-color: #fff;
      border: 2px dashed #d6d6d6;
      border-radius: 8px;
      transition: all 0.3s ease;
      padding: 20px;
      box-sizing: border-box;

      &:hover {
        border-color: #07a3ee;
        background-color: #f8f9fa;
      }
    }

    .file-input {
      position: absolute;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
      z-index: 1;
    }
  }
}
.upload-progress {
  min-height: 50px;
  display: flex;
  justify-content: center;
  position: relative;
  // margin: auto;
  &__empty {
    // margin: auto;
    position: absolute;
    // top: 0px;
    margin: 20px auto;
    width: 150px;
    height: 3px;
    // border-radius: 3px;
    background-color: #d8d8d8;
  }
  &__filled {
    position: absolute;
    width: 50%;
    height: 3px;
    // border-radius: 3px;
    background-color: #07a3ee;
    will-change: width;
    transition: width 100ms ease-in;
  }
  &__border {
    position: absolute;
    width: 100%;
    font-size: 12px;
    top: -20px;
    // height: px;
    // border: 1px solid #aaa;
    // border-radius: 3px;
    // box-shadow: inset 0 0 1px 1px rgba(0, 0, 0, .25);
    text-align: center;
    color: rgba(0, 0, 0, .75);
  }
}

.upload-button {
  background-image: -webkit-gradient(
    linear, right top, right bottom, color-stop(0%, #80d8ff), color-stop(100%, #07a3ee)
  );
  border: none;
  border-radius: 0;
  height: 50px;
  font-size: 18px;
  &[disabled] {
    pointer-events: none;
  }
  &:hover, &:focus {
    background-color: #07a3ee;
    background-image: none;
  }
}

.file-list {
  text-align: center;
  font-size: 12px;
}

.success-message {
  margin-top: 20px;
  text-align: center;
  &__icon {
    font-size: 40px;
    color: #00C700;
    margin: auto;
    display: inline-block;
  }
  &__text {
    margin-top: 10px;
    font-size: 14px;
  }
}

.errors {
  padding: 20px 0 0 0;
  color: #c83e3e;
  font-size: 12px;
  text-align: center;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 250ms ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 250ms ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(10px);
  opacity: 0;
}
</style>
